import React from 'react';

const PublicLayout = ({ children }) => children;

export default PublicLayout